<template>

  <div class="page">
      <div class="gridheader">
        <div class="row wrapper">
          <div class="col-md-4 title"><h1>{{$t('PATIENTS')}}</h1></div>
          <div class="col-md-4 search-form d-none d-md-block">
            <form method="get" action="">
              <div class="row">
                <div class="col-md-4">
                  <div class="input-group">
                    <select v-model="pagination.type" class="form-control">
                      <option value="patient">{{$t('PATIENT')}}</option>
                      <option value="company">{{$t('COMPANY')}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input type="text" v-model="pagination.query" class="form-control" v-bind:placeholder="(pagination.type == 'patient') ? $t('PATIENTNAME') : $t('COMPANYNAME')">
                    <div v-if="pagination.query == ''" class="input-group-addon"><img src="../assets/img/icon-search.svg" alt=""></div>
                    <div v-if="pagination.query != ''" v-on:click="pagination.query = ''" class="input-group-addon"><img class="emptysearch" src="../assets/img/icon-close.svg" alt=""></div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="text-left">
                    <b-form-checkbox v-model="pagination.showAll" class="grey"><span class="label">{{$t('SHOWALL')}}</span></b-form-checkbox>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-4 action d-none d-md-block"><a v-on:click="newPatient" class="btn btn-primary"><img src="../assets/img/user-plus.svg" alt=""> {{$t('ADDPATIENT')}}</a></div>
        </div>
      </div>
      <div class="row" v-if="!patients.root || patients.root.length == 0">
        <div class="col-12 center nothing">
          <img src="../assets/img/icon-novi-nalog-large.svg" alt="">
          <p>{{$t('CURRENTLYNOPATIENS')}}</p>
          <a v-on:click="newPatient" class="btn btn-primary d-none d-md-block"><img src="../assets/img/user-plus.svg" alt=""> {{$t('ADDPATIENT')}}</a>
        </div>
      </div>
      <div class="row" v-else>
        <div class="table-responsive">
          <table class="maintable">
            <thead>
              <tr>
                <td>{{$t('NAME')}}</td>
                <td></td>
                <td class="d-none d-md-table-cell">{{$t('ORDINATION')}}</td>
                <td class="d-none d-md-table-cell">{{$t('TECHNICLAB')}}</td>
                <td class="d-none d-md-table-cell">{{$t('LASTOPENFORM')}}</td>
                <td class="d-none d-md-table-cell">{{$t('STATUS')}}</td>
                <td class="d-none d-md-table-cell">{{$t('ACTIONS')}}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="patient in patients.root">
                <td v-on:click="toWorkOrder(patient.patientId)"><b>{{patient.name}} {{patient.surname}}</b></td>
                <td><a href="#" v-on:click.prevent="showPatientGallery(patient.patientId)"><img src="../assets/img/cell-camera.svg" alt=""></a></td>
                <td class="d-none d-md-table-cell" v-on:click="toWorkOrder(patient.patientId)">{{patient.ordination != null ? patient.ordination : patient.dummyPartner}}</td>
                <td class="d-none d-md-table-cell" v-on:click="toWorkOrder(patient.patientId)">{{patient.technicLab != null ? patient.technicLab : patient.dummyPartner}}</td>
                <td class="d-none d-md-table-cell" v-on:click="toWorkOrder(patient.patientId)">{{patient.openDateTime != null ? formatDate(patient.openDateTime) : $t('CURRENTLYNOWORKORDERS')}}</td>
                <td class="d-none d-md-table-cell status" v-on:click="toWorkOrder(patient.patientId)" v-bind:class="patient.workStatus">{{patient.statusOut}}</td>
                <td class="d-none d-md-table-cell"><a href="#" class="grid-action" v-on:click.prevent="deletePatient(patient.patientId)"><img src="../assets/img/icon-trash.svg" alt=""></a><a href="#" class="grid-action" v-on:click.prevent="editPatient(patient)"><img src="../assets/img/cell-edit.svg" alt=""></a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>



      <b-pagination v-if="patients.totalCount > 20" align="center" :total-rows="patients.totalCount" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>

      <b-modal centered size="lg" ref="newpatient" id="newpatient" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="savePatient" v-bind:title="$t('NEWPATIENT')">
          <form method="get" action="">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group" v-bind:class="(formError.name) ? 'has-danger' :''">
                  <label>{{ $t('NAME')}}</label>
                  <input type="text" v-model="formData.name" class="form-control secondary" v-bind:placeholder="$t('NAME')">
                  <div v-if="formError.name" class="form-control-feedback">{{formError.name}}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group" v-bind:class="(formError.surname) ? 'has-danger' :''">
                  <label>{{ $t('SURNAME')}}</label>
                  <input type="text" v-model="formData.surname" class="form-control secondary" v-bind:placeholder="$t('SURNAME')">
                  <div v-if="formError.surname" class="form-control-feedback">{{formError.surname}}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group" v-bind:class="(formError.birthDate) ? 'has-danger' :''">
                  <label>{{ $t('BIRTHDATE')}}</label>
                  <input type="text" v-model="formData.birthDate" class="form-control secondary" v-bind:placeholder="$t('BIRTHDATE')">
                  <div v-if="formError.birthDate" class="form-control-feedback">{{formError.birthDate}}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <b-form-checkbox value="real" v-model="formData.partnerType" class="grey"><span class="label">{{$t('REALPARTNER')}}</span></b-form-checkbox>
                  <b-form-checkbox value="dummy" v-model="formData.partnerType" class="grey"><span class="label">{{$t('DUMMYPARTNER')}}</span></b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="row" v-if="globals.companyType != 'ordination' && globals.companyType != 'technicallab'">
              <div class="col-md-12">
                <div class="form-group">
                  <b-form-checkbox value="ordination" v-model="formData.companyType" class="grey"><span class="label">{{$t('ORDINATION')}}</span></b-form-checkbox>
                  <b-form-checkbox value="technicallab" v-model="formData.companyType" class="grey"><span class="label">{{$t('TECHNICALLAB')}}</span></b-form-checkbox>
                </div>
              </div>
            </div>
            <div v-if="formData.partnerType == 'dummy'">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group" v-bind:class="(formError.dummyPartner) ? 'has-danger' :''">
                    <label>{{ $t('PARTNERNAME')}}</label>
                    <input type="text" v-model="formData.dummyPartner" class="form-control secondary" v-bind:placeholder="$t('PARTNERNAME')">
                    <div v-if="formError.dummyPartner" class="form-control-feedback">{{formError.dummyPartner}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="formData.partnerType == 'real'">
              <div class="row">
                <div class="col-md-12" v-if="selecttype == 'ordination'">
                  <div class="form-group" v-bind:class="(formError.ordinationId) ? 'has-danger' :''">
                    <label>{{ $t('ORDINATION')}}</label>
                    <autocomplete v-bind:setvalue="setOrdinationId" v-bind:value="formData.ordinationId" v-bind:placeholder="$t('ORDINATION')" v-bind:values="getOrdinationsOptions" v-bind:initdata="getOrdinationsInit"></autocomplete>
                    <div v-if="formError.ordinationId" class="form-control-feedback">{{formError.ordinationId}}</div>
                  </div>
                </div>
                <div class="col-md-12" v-if="selecttype == 'technicallab'">
                  <div class="form-group" v-bind:class="(formError.technicalLabId) ? 'has-danger' :''">
                    <label>{{ $t('TECHNICALLAB')}}</label>
                    <autocomplete v-bind:setvalue="setTechnicalLabId" v-bind:value="formData.technicalLabId" v-bind:placeholder="$t('TECHNICALLAB')" v-bind:values="getTechnicalLabOptions" v-bind:initdata="getTehnicalLabsInit"></autocomplete>
                    <div v-if="formError.technicalLabId" class="form-control-feedback">{{formError.technicalLabId}}</div>
                  </div>
                </div>
              </div>
            </div>
            <p class="bg-danger" v-if="savePatientResponse.error && savePatientResponse.notice">{{savePatientResponse.notice}}</p>
            <div class="clearfix"></div>
          </form>
      </b-modal>

      <patientsgallery v-bind:patientId="galleryPatientId"></patientsgallery>

    </div>



</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import PatientsGallery from '@/components/PatientsGallery.vue'

export default {
  name: 'Patients',
  components:
  {
    'patientsgallery': PatientsGallery
  },
  data: function()
  {
    return {
      galleryPatientId: false,
      formData: {
        id: '',
        name: '',
        surname: '',
        birthDate: '',
        ordinationId: '',
        technicalLabId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: 'technicallab'
      },
      formError: {},
      pagination:
      {
        showAll: false,
        query: '',
        currentPage: 1,
        limit: 20,
        type: 'patient'
      }
    };
  },
  created: function()
  {
    this.$store.commit('hideMenu');
    this.getPatients();
  },
  methods:
  {
    ...mapActions({
      savePatientInit: 'savePatient',
      getPatientsInit: 'getPatients',
      deletePatientInit: 'deletePatient',
      getOrdinations: 'getOrdinations',
      getTehnicalLabs: 'getTehnicalLabs'
    }),
    getOrdinationsInit: function()
    {
      var me = this;
      me.getOrdinations({onlyConnected: 'true'})
    },
    getTehnicalLabsInit: function()
    {
      var me = this;
      me.getTehnicalLabs({onlyConnected: 'true'})
    },
    showPatientGallery: function(patientId)
    {
      var me = this;
      me.galleryPatientId = false;
      Vue.nextTick(function()
      {
        me.galleryPatientId = patientId;
      })
    },
    toWorkOrder: function(patientId)
    {
      var me = this;
      me.$router.push('/patients/'+patientId)
    },
    savePatient: function(bvEvt)
    {
      var me = this;
      bvEvt.preventDefault();
      me.savePatientInit(me.formData);
    },
    getPatients: function()
    {
      var me = this;
      this.getPatientsInit(me.getParams);
    },
    deletePatient: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert', {text: me.$i18n.t('AREYOUSHURE'), btnAction: function(){ me.deletePatientInit({id: id}); }})
    },
    newPatient: function(data)
    {
      var me = this;
      me.formData = {
        id: '',
        name: '',
        surname: '',
        birthDate: '',
        ordinationId: '',
        technicalLabId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: 'technicallab'
      };
      me.$refs.newpatient.show()
    },
    editPatient: function(data)
    {
      var me = this;
      data = Object.assign({}, data, {});
      data.id = data.patientId;
      if(data.dummyPartner != '') data.partnerType = 'dummy';
      else data.partnerType = 'real';

      if(data.ordinationId != me.globals.companyId) data.companyType = 'ordination';
      else data.companyType = 'technicallab';


      me.formData = data;
      me.$refs.newpatient.show()
    },
    setOrdinationId: function(data)
    {
      var me = this;
      me.formData.ordinationId = data;
    },
    setTechnicalLabId: function(data)
    {
      var me = this;
      me.formData.technicalLabId = data;
    }
  },
  watch:
  {
    savePatientResponse: function(val)
    {
      var me = this;

      me.formError = {};

      if(val.error == true)
      {
        if(typeof val.notice == 'object')
        {
          me.formError = val.notice;
          val.notice = '';
        }
      }
      else
      {
        this.$refs.newpatient.hide()
        me.$router.push('/patients/'+val.lastId)
        //me.getPatients();
        for(var key in me.formData)
        {
          me.formData[key] = '';
        }
      }
    },
    deletePatientResponse: function(val)
    {
      var me = this;
      me.getPatients();
    },
    'pagination.query': function()
    {
      var me = this;
      me.getPatients();
    },
    'pagination.type': function()
    {
      var me = this;
      me.getPatients();
    },
    'pagination.showAll': function()
    {
      var me = this;
      me.getPatients();
    },
    'pagination.currentPage': function(newValue, oldValue)
    {
      var me = this;
      me.getPatients();
    }
  },
  computed:
  {
    ...mapGetters([
      'globals',
      'modalAlert',
      'patients',
      'ordinations',
      'tehnicallabs',
      'savePatientResponse',
      'deletePatientResponse'
    ]),
    selecttype: function()
    {
      var me = this;
      //'admin','ordination','technicallab','ordinationandlab'
      if(me.globals.companyType == 'ordination')
      {
        return 'technicallab';
      }

      if(me.globals.companyType == 'technicallab')
      {
        return 'ordination';
      }

      if(me.formData.companyType == 'ordination')
      {
        return 'ordination';
      }

      if(me.formData.companyType == 'technicallab')
      {
        return 'technicallab';
      }
    },
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    },
    getOrdinationsOptions: function()
    {
      var me = this,
        options = [];

      for(var i=0;i<me.ordinations.root.length;i++)
      {
        var ordination = me.ordinations.root[i];
        options.push({value: ordination.companyId, text: ordination.companyName})
      }

      return options;
    },
    getTechnicalLabOptions: function()
    {
      var me = this,
        options = [];

      for(var i=0;i<me.tehnicallabs.root.length;i++)
      {
        var tehnicallab = me.tehnicallabs.root[i];
        options.push({value: tehnicallab.companyId, text: tehnicallab.companyName})
      }

      return options;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Patients.vue